module.exports = __webpack_public_path__ + "fonts/Calibre-BlackItalic.57442766.woff2";